import { render, staticRenderFns } from "./lists.page.vue?vue&type=template&id=9d9dc66a&scoped=true&"
import script from "./lists.page.vue?vue&type=script&lang=js&"
export * from "./lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9dc66a",
  null
  
)

export default component.exports